import { Fragment, useEffect, useState } from "react";
import "./MyPicks.scss";
import axios from "axios";
import { UIPick, UpdatePicksResponse, UserPicksResponse } from "models/Models";
import UserService from "services/UserService";
import { Identity } from "models/LoginInfo";
import clx from "classnames";
import { Button, CircularProgress, Tab, Tabs } from "@mui/material";
import { TabPanel } from "components/TabPanel";
import { RoundSeries } from "fragments/RoundSeries";
import * as PickService from "services/PickService";

export const MyPicks = () => {
  const [picks, setPicks] = useState<UIPick[]>([]);
  const [user, setUser] = useState<Identity>();
  const [hasChanges, setHasChanges] = useState<boolean>(false);
  const [currentTabIndex, setCurrentTabIndex] = useState<number>(0);
  const [errors, setErrors] = useState<string[]>([]);
  const [updateCount, setUpdateCount] = useState<number>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSaving, setIsSaving] = useState<boolean>(false);

  useEffect(() => {
    setUser(UserService.getUserInfo());
    axios.get<UserPicksResponse>(`${process.env.REACT_APP_API_URL}/pick`).then((r) => {
      const uipicks = PickService.createUIPicks(r.data);
      const sorted = uipicks
        .filter((c) => c.teamId !== 0)
        .map((c) => c.round)
        .sort();
      if (sorted.length > 0) setCurrentTabIndex(sorted[sorted.length - 1] - 1);
      setPicks(uipicks);
      setIsLoading(false);
    });
  }, []);

  const submitPicks = async () => {
    setIsSaving(true);
    var response = await axios.put<UpdatePicksResponse>(`${process.env.REACT_APP_API_URL}/pick`, { picks: picks });
    if (response.data) {
      setErrors(response.data.errors);
      PickService.createUIPicks(response.data);
      setUpdateCount(response.data.updateCount);
    }
    setHasChanges(false);
    setIsSaving(false);
  };

  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  };

  const onGamesChanged = (pick: UIPick, games: number) => {
    pick.games = games;
    setPicks(picks.slice());
    setHasChanges(true);
  };

  const onTeamSelected = (pick: UIPick, teamId: number) => {
    if (pick.teamId !== teamId) {
      pick.teamId = teamId;
      pick.games = 0;
      setPicks(picks.slice());
      setHasChanges(true);
    }
  };

  const West = 2;
  const East = 1;
  return (
    <div className="bracket-root">
      <div className="bracket">
        <h2>
          {user?.teamName} Picks
          <Button variant={hasChanges ? "contained" : "outlined"} onClick={submitPicks} disabled={isSaving} className={clx("submit", { hasChanges: hasChanges })}>
            {isSaving ? <CircularProgress size={20} color="inherit" /> : <span className="submit-text">Submit</span>}
          </Button>
          {errors && errors.length > 0 && (
            <div className="errors">
              {errors.map((e) => (
                <div key={e}>{e}</div>
              ))}
            </div>
          )}
          {updateCount !== undefined && (
            <span className="update-message">
              Updated <span className="update-count">{updateCount}</span> Picks.
            </span>
          )}
        </h2>
        <label style={{ height: 30 }} className="submitResult" ng-bind="submitResult"></label>
        {isLoading ? (
          <div className="bracket-loading">
            <CircularProgress />
          </div>
        ) : null}
        <div className="mobile-bracket" style={{ display: isLoading ? "none" : undefined }}>
          <Tabs className="md-accent" value={currentTabIndex} onChange={(e, newIndex) => setCurrentTabIndex(newIndex)}>
            <Tab label="Round 1" {...a11yProps(0)} />
            <Tab label="Round 2" {...a11yProps(0)} />
            <Tab label="Round 3" {...a11yProps(0)} />
            <Tab label="Cup Finals" {...a11yProps(0)} />
          </Tabs>
          <TabPanel value={currentTabIndex} index={0} className="tab-panel">
            <div className="mobile-round">
              <div className="mobile-series">
                <RoundSeries picks={picks} round={1} division={West} onGamesChanged={onGamesChanged} onTeamSelected={onTeamSelected} />
              </div>
              <div className="mobile-series">
                <RoundSeries picks={picks} round={1} division={East} onGamesChanged={onGamesChanged} onTeamSelected={onTeamSelected} />
              </div>
            </div>
          </TabPanel>
          <TabPanel value={currentTabIndex} index={1} className="tab-panel">
            <div className="mobile-round">
              <div className="mobile-series">
                <RoundSeries picks={picks} round={2} division={West} onGamesChanged={onGamesChanged} onTeamSelected={onTeamSelected} />
              </div>
              <div className="mobile-series">
                <RoundSeries picks={picks} round={2} division={East} onGamesChanged={onGamesChanged} onTeamSelected={onTeamSelected} />
              </div>
            </div>
          </TabPanel>
          <TabPanel value={currentTabIndex} index={2} className="tab-panel">
            <div className="mobile-round">
              <div className="mobile-series">
                <RoundSeries picks={picks} round={3} division={West} onGamesChanged={onGamesChanged} onTeamSelected={onTeamSelected} />
              </div>
              <div className="mobile-series">
                <RoundSeries picks={picks} round={3} division={East} onGamesChanged={onGamesChanged} onTeamSelected={onTeamSelected} />
              </div>
            </div>
          </TabPanel>
          <TabPanel value={currentTabIndex} index={3} className="tab-panel">
            <div className="mobile-round">
              <div className="mobile-series">
                <RoundSeries picks={picks} round={4} division={West} onGamesChanged={onGamesChanged} onTeamSelected={onTeamSelected} />
              </div>
            </div>
          </TabPanel>
        </div>
        <div className="desktop-bracket" style={{ display: isLoading ? "none" : undefined }}>
          <main className="tournament">
            <div className="round round-1 west">
              <RoundSeries picks={picks} round={1} division={West} onGamesChanged={onGamesChanged} onTeamSelected={onTeamSelected} />
            </div>
            <div className="round round-2 west">
              {/* <div className="spacer">&nbsp;</div> */}
              <RoundSeries picks={picks} round={2} division={West} onGamesChanged={onGamesChanged} onTeamSelected={onTeamSelected} spacer={true} />
            </div>
            <div className="round round-3 west">
              {/* <div className="spacer">&nbsp;</div> */}
              <RoundSeries picks={picks} round={3} division={West} onGamesChanged={onGamesChanged} onTeamSelected={onTeamSelected} />
            </div>
            <div className="round round-4 cupFinal">
              <RoundSeries picks={picks} round={4} division={West} onGamesChanged={onGamesChanged} onTeamSelected={onTeamSelected} />
            </div>
            <div className="round round-3 east">
              {/* <div className="spacer">&nbsp;</div> */}
              <RoundSeries picks={picks} round={3} division={East} onGamesChanged={onGamesChanged} onTeamSelected={onTeamSelected} />
            </div>
            <div className="round round-2 east">
              {/* <div className="spacer">&nbsp;</div> */}
              <RoundSeries picks={picks} round={2} division={East} onGamesChanged={onGamesChanged} onTeamSelected={onTeamSelected} spacer={true} />
            </div>
            <div className="round round-1 east">
              <RoundSeries picks={picks} round={1} division={East} onGamesChanged={onGamesChanged} onTeamSelected={onTeamSelected} />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};
